import { Position, Toaster } from "@blueprintjs/core"
import './Toaster.css'

export const AppToaster = Toaster.create({
    className: "recipe-toaster",
    position: Position.TOP,
    maxToasts: 1,
})